// extracted by mini-css-extract-plugin
export default {"Edit":"RectangleEdit_Edit__lG69s","RectangleStart":"RectangleEdit_RectangleStart__ndAHg","RectangleEnd":"RectangleEdit_RectangleEnd__c6fJW"};